import { useMemo } from "react";
import { useAuth } from "../components/auth/AuthContext";

export function useFeatureFlags() {
  const { user } = useAuth();
  return useMemo(() => {
    if (!user) return {};
    // Prefer server-provided features when available
    const server =
      user.server && user.server.features ? user.server.features : null;
    if (server && Object.keys(server).length > 0) return server;

    // Fallback derived flags from roles/claims
    const roles =
      user.roles ||
      (user.server && user.server.roles) ||
      (user.claims && user.claims.roles) ||
      [];
    const isAdmin =
      Boolean(user.isAdmin) ||
      (Array.isArray(roles) && roles.includes("DIXI_ADMIN")) ||
      (user.claims && user.claims.role === "DIXI_ADMIN");
    return {
      adminUi: !!isAdmin,
      enableDbDelete:
        !!isAdmin || (Array.isArray(roles) && roles.includes("DB_DELETE")),
    };
  }, [user]);
}

export function useIsAdmin() {
  const { user } = useAuth();
  return useMemo(() => {
    if (!user) return false;
    if (typeof user.isAdmin === "boolean") return user.isAdmin;
    const serverAdmin =
      user.server && user.server.features && user.server.features.adminUi;
    if (serverAdmin) return true;
    const roles =
      user.roles ||
      (user.server && user.server.roles) ||
      (user.claims && user.claims.roles) ||
      [];
    if (Array.isArray(roles) && roles.includes("DIXI_ADMIN")) return true;
    if (user.claims && user.claims.role === "DIXI_ADMIN") return true;
    return false;
  }, [user]);
}
